import { Alert as AntAlert } from 'antd';
import { AlertProps } from 'antd/es/alert';
import clsx from 'clsx';
import styles from './index.module.scss';

function Alert(props: AlertProps) {
  const { className, type = 'info', ...rest } = props;
  const alertClassName = clsx(styles.container, styles[type], className);
  return <AntAlert className={alertClassName} type={type} {...rest} />;
}

export default Alert;
